import { baseAxiosKalteng } from "../../index";

export async function getAllPengajuanKalteng(dispatch, data, history) {
  try {
    const response = await baseAxiosKalteng.get(
      `webPengajuan/getPengajuanByLogin?status=${data.status}&page=${data.page}&limit=${data.limit}&cari=${data.cari}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    dispatch({ type: "SET_ALL_PENGAJUAN", data: response.data });
    return response.status;
  } catch (err) {
    return err.response;
  }
}

export async function getAllPencairanKalteng(dispatch, data, history) {
  // console.log(data, "PPPPP");
  try {
    const response = await baseAxiosKalteng.get(
      `webPengajuan/getPengajuanByLogin?status=${data.status}&page=${data.page}&limit=${data.limit}&cari=${data.cari}&tglAwal=${data.tglAwal}&tglAkhir=${data.tglAkhir}`,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    dispatch({ type: "SET_ALL_PENCAIRAN", data: response.data });
    return response.status;
  } catch (err) {
    return err.response;
  }
}

export async function getTotalPencairanKalteng(dispatch, data, history) {
  try {
    const response = await baseAxiosKalteng.post(
      "webDashboard/getTotalPencairan",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    // dispatch({
    //   type: "SET_ALL_TOTAL_PENCAIRAN",
    //   data: response.data.totalNominal,
    // });
    return response;
  } catch (err) {
    return err.response;
  }
}

// export async function getTotalPencairanKalteng(dispatch, data, history) {
//   try {
//     const response = await baseAxiosKalteng.post(
//       "webDashboard/getTotalPencairan",
//       data,
//       {
//         headers: { token: localStorage.getItem("token") },
//       }
//     );
//     // dispatch({
//     //   type: "SET_ALL_TOTAL_PENCAIRAN",
//     //   data: response.data.totalNominal,
//     // });
//     return response;
//   } catch (err) {
//     return err.response;
//   }
// }

export async function getTotalTargetUserKalteng(dispatch, data, history) {
  try {
    const response = await baseAxiosKalteng.post(
      "webDashboard/getTargetUserLogin",
      data,
      {
        headers: { token: localStorage.getItem("token") },
      }
    );
    // dispatch({
    //   type: "SET_ALL_TOTAL_PENCAIRAN",
    //   data: response.data.totalNominal,
    // });
    return response;
  } catch (err) {
    return err.response;
  }
}

// export async function revisiPengajuan(data) {
//   try {
//     const response = await baseAxiosKalteng.post(
//       "webPengajuan/revisiPengajuanDariAtasan",
//       data,
//       {
//         headers: {
//           token: localStorage.getItem("token"),
//         },
//       }
//     );
//     return response;
//   } catch (err) {
//     return err.response;
//   }
// }

// export async function pengajuanBPD(data) {
//   try {
//     const response = await baseAxiosKalteng.post("webApiBpd/pengajuan", data, {
//       headers: {
//         token: localStorage.getItem("token"),
//       },
//     });
//     // console.log(response, "DARI AXIOSSSSSS");
//     return response;
//   } catch (err) {
//     return err.response;
//   }
// }

export async function updateStatusPengajuanKalteng(data) {
  try {
    const response = await baseAxiosKalteng.post(
      "webPengajuan/updateStatusPengajuanManual",
      data,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );
    // console.log(response, "DARI AXIOSSSSSS");
    return response;
  } catch (err) {
    return err.response;
  }
}
